import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import Hero from '../components/Hero';
import UsageStats from '../components/UsageStats';
import ProPlanTeaser from '../components/ProPlanTeaser';

const HomePage: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 antialiased">
      <Header />
      <div className="bg-amber-50 border-b border-amber-200">
        <div className="mx-auto max-w-7xl px-6 py-4 flex items-start gap-3">
          <span className="text-xl leading-none" aria-hidden="true">🚧</span>
          <div>
            <p className="text-sm font-semibold text-amber-900">
              Beta is closed — we're re-architecting QuizCrunch
            </p>
            <p className="text-sm text-amber-800">
              We're not running quizzes right now while we rebuild things under the hood.
              We don't have a date yet for when we'll be back up — thanks for your patience!
            </p>
          </div>
        </div>
      </div>
      <main className="mx-auto max-w-7xl px-6 py-8">
        <Hero />
        <ProPlanTeaser />
        {/* Only show usage stats when user is not logged in (for advertisement) */}
        {!isAuthenticated && <UsageStats />}
      </main>
    </div>
  );
};

export default HomePage;
